import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesRefunds } from "../../constants";
import { IRefund } from "../../financial.types";

export const requestRefundById = async (id: string): Promise<IRefund> => {
  return await instance.get(buildUrl(ApiRoutesRefunds.Refunds, id));
};
